// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-toggle[data-v-4f36a0d7] {
  cursor: pointer;
}
.user-control a[data-v-4f36a0d7] {
  color: #fff;
}
.user-control a.icon[data-v-4f36a0d7] {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.user-control a.icon[data-v-4f36a0d7]:before {
  color: #fff;
  margin-right: 0.5rem;
}
.user-control a.icon[data-v-4f36a0d7]:after {
  color: #fff;
  margin-left: 0.5rem;
}
.navbar .user-menu[data-v-4f36a0d7] {
  margin-top: 10px;
}
#skip-to-main[data-v-4f36a0d7] {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.5rem;
  margin-top: 0.25rem;
  z-index: 1002;
}
`, "",{"version":3,"sources":["webpack://./AppShell.3.vue","webpack://./../AppShell.3.vue"],"names":[],"mappings":"AACA;EACI,eAAA;ACAJ;ADEA;EACI,WAAA;ACAJ;ADCI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;ACCR;ADAQ;EACI,WAAA;EACA,oBAAA;ACEZ;ADAQ;EACI,WAAA;EACA,mBAAA;ACEZ;ADEA;EACI,gBAAA;ACAJ;ADEA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;ACAJ","sourcesContent":["\n.dropdown-toggle {\n    cursor: pointer;\n}\n.user-control a {\n    color: #fff;\n    &.icon {\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        &:before {\n            color: #fff;\n            margin-right: 0.5rem;\n        }\n        &:after {\n            color: #fff;\n            margin-left: 0.5rem;\n        }\n    }\n}\n.navbar .user-menu {\n    margin-top: 10px;\n}\n#skip-to-main {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 0.5rem;\n    margin-top: 0.25rem;\n    z-index: 1002;\n}\n",".dropdown-toggle {\n  cursor: pointer;\n}\n.user-control a {\n  color: #fff;\n}\n.user-control a.icon {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n}\n.user-control a.icon:before {\n  color: #fff;\n  margin-right: 0.5rem;\n}\n.user-control a.icon:after {\n  color: #fff;\n  margin-left: 0.5rem;\n}\n.navbar .user-menu {\n  margin-top: 10px;\n}\n#skip-to-main {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 0.5rem;\n  margin-top: 0.25rem;\n  z-index: 1002;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
